var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { RestServiceBase, RestResult } from "@ane/core/lib/services/RestServiceBase";
import EnvironmentService from "@ane/core/lib/services/EnvironmentService";
import MasterDataConstants from "../constants/FeatureDataConstants.js";
import { parseError } from "./expapiv2/ExpApiV2.utils.js";
import { WPSProxyConverter } from "@ane/core/lib/services/WPSProxy";
var __defProp2 = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp2(target, key, result);
  return result;
};
let MdsDataplaneResources = class extends RestServiceBase {
  constructor() {
    super(EnvironmentService.endpoints.mds, "", parseError);
    __publicField(this, "apiVersion", "2019-11-01-preview");
    __publicField(this, "_errorMessage", (RestResult2, response) => response.ExceptionMessage);
  }
  getExperimentationGroups(workspaceId) {
    return __async(this, null, function* () {
      const workspace = EnvironmentService.getWorkspaceIdOrDefault(workspaceId);
      const address = `/workspaces/${workspace}/experimentationGroups?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getExperimentationGroupById(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      let address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getRootExperimentationGroup(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getExperimentationGroupRootPath(workspaceId) {
    return __async(this, null, function* () {
      var _a;
      const address = `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      if (!!result && result.isSuccessful()) {
        return (_a = result.getSuccessData()) == null ? void 0 : _a.Path;
      }
      return "";
    });
  }
  getExperimentationGroup(workspaceId, path) {
    return __async(this, null, function* () {
      var _a;
      const result = yield this.getExperimentationGroupV2(workspaceId, path);
      if (!!result && result.isSuccessful()) {
        return (_a = result.getSuccessData()) == null ? void 0 : _a.ID;
      }
      return "";
    });
  }
  getExperimentationGroupV2(workspaceId, path = null) {
    return __async(this, null, function* () {
      const address = !!path ? `/workspaces/${workspaceId}/experimentationGroups/path?apiversion=${this.apiVersion}&path=${encodeURIComponent(path)}` : `/workspaces/${workspaceId}/experimentationGroups/root?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getSections() {
    return __async(this, null, function* () {
      const address = `/sections?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      result.ensureSuccess();
      return result.getSuccessData();
    });
  }
  getPaths(workspaceId, includeHidden) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups?apiversion=${this.apiVersion}${includeHidden ? "&includeHidden=true" : ""}`;
      const result = yield this._get(address);
      return result.getSuccessData().map((eg) => eg.Path);
    });
  }
  /**
   * Get paths under specific experimentation group
   * @param workspaceId
   * @param experimentationGroup
   */
  getChildPaths(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}/children?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      return result.getSuccessData().map((eg) => eg.Path);
    });
  }
  getSchema(section) {
    return __async(this, null, function* () {
      const address = `/sections/${section}/schema?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      result.ensureSuccess();
      return result.getSuccessData();
    });
  }
  getConfig(r) {
    return __async(this, null, function* () {
      let address = `/workspaces/${r.workspaceId}/experimentationGroups/${r.experimentationGroup}/sections/${r.section}?apiversion=${this.apiVersion}`;
      address += !!r.snapshot ? `&snapshotName=${r.snapshot}` : "";
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getConfigWithTypeV2(r) {
    return __async(this, null, function* () {
      let address = `/workspaces/${r.workspaceId}/experimentationGroups/${r.experimentationGroup}/sections/${r.section}?apiversion=${this.apiVersion}`;
      address += !!r.snapshot ? `&snapshotName=${r.snapshot}` : "";
      return yield this._get(address);
    });
  }
  getConfigWithType(r) {
    return __async(this, null, function* () {
      let address = `/workspaces/${r.workspaceId}/experimentationGroups/${r.experimentationGroup}/sections/${r.section}?apiversion=${this.apiVersion}`;
      address += !!r.snapshot ? `&snapshotName=${r.snapshot}` : "";
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getSnapshots(workspaceId, section) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/sections/${section}/snapshots`;
      const result = yield this._get(address);
      return result.getSuccessData();
    });
  }
  getDefaultSnapshot(workspaceId, section) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/sections/${section}/metadata?apiversion=${this.apiVersion}`;
      const result = yield this._get(address);
      return result.getSuccessData().DefaultSnapshot;
    });
  }
  getDefaultSnapshotV2(workspaceId, section) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/sections/${section}/metadata?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getMergeMode(workspaceId, section, snapshot) {
    return __async(this, null, function* () {
      if (snapshot) {
        const address = `/workspaces/${workspaceId}/sections/${section}/snapshots/${snapshot}/metadata`;
        const result = yield this._get(address);
        return result.getSuccessData().MergeMode;
      }
      return "";
    });
  }
  getSnapshotUpdateStatus(workspaceId, section, snapshot) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/sections/${section}/snapshots/${snapshot}/updateStatus`;
      const result = yield this._get(address);
      if (result.statusCode === 404) {
        return null;
      }
      result.ensureSuccess();
      return result.getSuccessData();
    });
  }
  setSection(r) {
    return __async(this, null, function* () {
      const address = `/workspaces/${r.workspaceId}/experimentationGroups/${r.experimentationGroup}/sections/${r.section}?merge=${r.mergemode}&apiversion=${this.apiVersion}`;
      const body = JSON.parse(r.config);
      const result = yield this._put(body, address);
      if (result.statusCode === 403) {
        throw new Error(
          `You are not authorized to make changes here. Please contact your admin to give you access to section ${r.section}.`
        );
      }
      result.ensureSuccess();
      return result.getSuccessData().SnapshotName;
    });
  }
  setExperimentationGroup(r) {
    return __async(this, null, function* () {
      const address = `/workspaces/${r.workspaceId}/experimentationGroups/${r.experimentationGroup}?apiversion=${this.apiVersion}`;
      const body = JSON.parse(r.config);
      const result = yield this._put(body, address);
      if (result.statusCode === 403) {
        throw new Error(
          "You are not authorized to create an Experimentation Group here. Please contact your admin to give you access."
        );
      }
      result.ensureSuccess();
    });
  }
  setIsHidden(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}?apiversion=${this.apiVersion}`;
      const result = yield this._delete(address);
      result.ensureSuccess();
    });
  }
  isAuthorizedRestResult(workspaceId, experimentationGroup, actionname) {
    return __async(this, null, function* () {
      const url = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}/actionauthorized/${actionname}?apiversion=${this.apiVersion}`;
      const result = yield this._get(url);
      if (result.statusCode === 403 || result.statusCode === 404) {
        return RestResult.fromResult(false, true);
      } else if (result.statusCode === 200) {
        return RestResult.fromResult(true, true);
      }
      return result;
    });
  }
  isAuthorizedonEwRestResult(workspaceId, actionname) {
    return __async(this, null, function* () {
      const url = `/workspaces/${workspaceId}/actionauthorized/${actionname}?apiversion=${this.apiVersion}`;
      const result = yield this._get(url);
      if (result.statusCode === 403) {
        return RestResult.fromResult(false, true);
      } else if (result.statusCode === 200) {
        return RestResult.fromResult(true, true);
      }
      return result;
    });
  }
  previewConfig(workspaceId, section, experimentationGroup, payload) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}/sections/${section}/preview?includeDiff=true`;
      const result = yield this._post(payload, address);
      result.ensureSuccess();
      return result.getSuccessData();
    });
  }
  getPreviewContent(workspaceId, section, experimentationGroup, payload, targetPath, mergemode) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/experimentationGroups/${experimentationGroup}/sections/${section}/previewChange?descendentPath=${encodeURIComponent(
        targetPath
      )}&merge=${mergemode}`;
      const result = yield this._post(payload, address);
      result.ensureSuccess();
      return result.getSuccessData();
    });
  }
  loadFlightControl(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      let request = {
        experimentationGroup,
        section: MasterDataConstants.flightControlSection,
        workspaceId
      };
      const result = yield this.getConfigWithTypeV2(request);
      return result.getSuccessData(this._errorMessage);
    });
  }
  loadTicketCategories(workspaceId, experimentationGroup) {
    return __async(this, null, function* () {
      let request = {
        experimentationGroup,
        section: MasterDataConstants.ticketCategories,
        workspaceId
      };
      const result = yield this.getConfigWithTypeV2(request);
      return result.getSuccessData(this._errorMessage);
    });
  }
  getAnalysisRules(workspaceId) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  getAnalysisRule(workspaceId, analysisRuleName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
  deleteAnalysisRule(workspaceId, analysisRuleName) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._delete(address);
    });
  }
  createOrUpdateAnalysisRule(workspaceId, analysisRuleName, analysisRule) {
    return __async(this, null, function* () {
      const address = `/workspaces/${workspaceId}/analysisRules/${analysisRuleName}?apiversion=${this.apiVersion}`;
      return yield this._put(analysisRule, address);
    });
  }
  /**
   * Workspace migration
   */
  getWorkspaceMigrationStatus() {
    return __async(this, null, function* () {
      const address = `/workspaceMigrationStatus?apiversion=${this.apiVersion}`;
      return yield this._get(address);
    });
  }
};
MdsDataplaneResources = __decorateClass([
  WPSProxyConverter()
], MdsDataplaneResources);
const MdsDataplaneResource = new MdsDataplaneResources();
export {
  MdsDataplaneResources,
  MdsDataplaneResource as default
};
//# sourceMappingURL=MdsDataplaneResource.js.map
